export default {
    "subscription.title": "Mon Abonnement",
    "subscription.subtitle": "Analysez et gérez votre accès au contenu CitoyenPro.",

    "subscription.empty.title": "Aucun abonnement actif",
    "subscription.empty.desc": "Passez au niveau supérieur dès aujourd'hui et maîtrisez tout le contenu officiel avec nos outils premium.",
    "subscription.empty.cta": "Voir les offres",

    "subscription.card.billing_monthly": "Facturation mensuelle",
    "subscription.card.billing_yearly": "Facturation annuelle",
    "subscription.card.status.active": "Abonnement Actif",
    "subscription.card.status.canceled": "Annulé (Accès maintenu)",
    "subscription.card.status.expired": "Expiré",
    "subscription.card.start_date": "Date de début",
    "subscription.card.next_renewal": "Prochain renouvellement",
    "subscription.card.end_date": "Date d'échéance",

    "subscription.benefits.title": "Vos avantages {{plan}}",
    "subscription.benefits.standard": [
        "Tous les thèmes débloqués",
        "Quiz et Flashcards illimités",
        "Statistiques détaillées",
        "Sans publicité"
    ],
    "subscription.benefits.premium": [
        "Tous les thèmes débloqués",
        "Examens blancs illimités",
        "Audioguides complets",
        "Flashcards & Quiz illimités",
        "Support prioritaire"
    ],

    "subscription.actions.continue": "Continuer l'apprentissage",
    "subscription.actions.compare": "Comparer les plans",
    "subscription.actions.renew": "Renouveler l'abonnement",

    "subscription.manage.title": "Gérer mes paiements",
    "subscription.manage.desc": "Mettez à jour votre mode de paiement ou téléchargez vos factures via notre portail Stripe sécurisé.",
    "subscription.manage.button": "Gérer l'abonnement",
    "subscription.manage.error": "Erreur : {{message}}",
    "subscription.manage.error_default": "Impossible d'accéder au portail client.",
    "subscription.manage.session_expired": "Votre session a expiré. Veuillez vous reconnecter.",

    "subscription.support.title": "Un problème ?",
    "subscription.support.desc": "Notre équipe est là pour vous aider avec vos questions de facturation ou techniques."
};
